/* MIX AND MATCH */
(function () {
  window.addEventListener("DOMContentLoaded", (e) => {
    window.addEventListener("shopify-variants:switch-variant", (e) => {
      let selectedProductId = e.detail.product.id;
      let selectedVariantId = e.detail.variant.id;
      let mixMatchElm = document.querySelector(
        `[data-mix-match-ids="${selectedProductId}"]`
      );
      let mixMatchTbl = document.querySelector("#mmtable");
      let xplusCustomer = JSON.parse(
        mixMatchTbl.getAttribute("data-xmiles-plus-customer")
      );
      let xplusPricing = document.querySelector(".xplus-price-wrapper");
      let productPrice = document.querySelector("[data-price]");

      xplusPricing.style.display = "none";
      productPrice.classList.remove("xplus-reduced");

      // Hide mix and match table
      if (mixMatchTbl) mixMatchTbl.style.display = "none";

      // No mix match variants
      if (!mixMatchElm) return;

      let mixMatchInput = document.querySelector(
        `[data-mix-match-input="${selectedProductId}"]`
      );
      let mixMatchIds = JSON.parse(mixMatchElm.innerHTML);

      // Remove existing input
      if (mixMatchInput) mixMatchInput.remove();

      if (mixMatchIds.includes(selectedVariantId)) {
        if (xplusCustomer) {
          xplusPricing.querySelector("span").innerHTML = Shopify.formatMoney(
            e.detail.variant.price *
              parseFloat(xplusPricing.getAttribute("data-price-adjustment")),
            xplusPricing.getAttribute("data-price-format")
          );
          productPrice.classList.add("xplus-reduced");
          xplusPricing.style.display = "inline-flex";
        } else if (mixMatchTbl) {
          mixMatchTbl.style.display = "block";
        }

        // Add new line item property input
        let newField = document.createElement("input");
        newField.setAttribute("type", "hidden");
        newField.setAttribute("name", "properties[_mix_match]");
        newField.setAttribute("data-mix-match-input", selectedProductId);
        newField.value = true;
        mixMatchElm.parentNode.insertBefore(newField, mixMatchElm.nextSibling);
      }
    });
  });

  /* CHANGE VARIANT SWATCH */
  window.addEventListener("shopify-variants:switch-variant", (e) => {
    let selectedProduct = e.detail.product;
    let selectedVariant = e.detail.variant;
    let productJSON = JSON.parse(
      document.querySelector('[data-section-type="static-product"]').innerHTML
    ).product;
    let productVariants = productJSON.variants;

    const swatchOptions = ["Flavour", "Colour", "Type"];

    if (!selectedProduct.options.some((r) => swatchOptions.indexOf(r) >= 0))
      return false;

    let filterVariants = productVariants.filter(
      (variant) => variant.option1 === selectedVariant.option1
    );

    filterVariants.forEach((variant) => {
      let swatch = document.querySelector(
        `[data-swatch-tooltip="${variant.option2}"] .swatch-inner`
      );
      swatch.style.backgroundImage = `url(${variant.featured_image.src})`;
    });
  });

  /* SHOW/HIDE VARIANT SWATCH */
  window.addEventListener("shopify-variants:switch-variant", (e) => {
    let product = e.detail.product;
    let selectedVariant = e.detail.variant;
    let options = document.querySelectorAll(
      '.option-value-input[name="Flavour"], .option-value-input[name="Colour"], .option-value-input[name="Type"]'
    );

    if (product.options.length <= 1) return;

    let filterVariants = product.variants.filter(
      (variant) => variant.option1 === selectedVariant.option1
    );
    let optionValues = filterVariants.map((variant) => variant.option2);

    options.forEach((option) => {
      if (optionValues.includes(option.value)) {
        option.parentElement.parentElement.style.display = "inline-block";
      } else {
        option.parentElement.parentElement.style.display = "none";
      }
    });
  });
})();
